import { render, staticRenderFns } from "./scls.vue?vue&type=template&id=54728553&scoped=true&"
import script from "./scls.vue?vue&type=script&lang=js&"
export * from "./scls.vue?vue&type=script&lang=js&"
import style0 from "./scls.vue?vue&type=style&index=0&id=54728553&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54728553",
  null
  
)

export default component.exports